export type PageToken = number | "ellipsis";

export function getPaginationItems(current: number, totalPages: number): PageToken[] {
  if (totalPages <= 5) {
    return Array.from({ length: Math.max(totalPages, 0) }, (_, index) => index + 1);
  }
  if (current <= 3) {
    return [1, 2, 3, 4, "ellipsis", totalPages];
  }
  if (current >= totalPages - 2) {
    return [1, "ellipsis", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }
  return [1, "ellipsis", current - 1, current, current + 1, "ellipsis", totalPages];
}
